import { __module as t } from "./ghl-ui.es1704.js";
(function(u, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, o) {
    if (o.length < r)
      throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + o.length + " present");
  }
  u.exports = e.default;
})(t, t.exports);
var l = t.exports;
export {
  l as r
};
